// Resolve a path against VITE_API_BASE. Empty base = same-origin (Vite dev
// proxy in development; reverse-proxied prod). Set to a full origin like
// "https://api.coresmith.dev" to call a separate API host (CORS allowlist
// must include the web origin).
const BASE = (import.meta.env.VITE_API_BASE ?? "").replace(/\/$/, "");

export const apiUrl = (path: string): string =>
  `${BASE}${path.startsWith("/") ? path : `/${path}`}`;
